import ImgCover, { ImgCoverStyle } from './ImgCover';

export { ImgCoverStyle };

export default ImgCover;
